// client/src/components/EvaluationReadOnly.jsx
import React from 'react';
import { Card, Row, Col, Typography, Tag, Divider } from 'antd';

const { Title, Text } = Typography;

export default function EvaluationReadOnly({ doc }) {
  if (!doc) return null;

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <Card title={`ผลการประเมินปี ${doc.year} — ${doc.type}`}>
        <div style={{ marginBottom: 12 }}>
          <Tag color="blue">คะแนนเต็มรวม: {doc.totals?.sumFullMark ?? '-'}</Tag>
          <Tag color="green">คะแนนที่ได้: {doc.totals?.sumEarned ?? '-'}</Tag>
          <Tag color="purple">ผลลัพธ์: {doc.totals?.grade ?? '-'}</Tag>
        </div>
      </Card>

      <Card title="ส่วนที่ 1 ข้อมูลผู้รับการประเมิน">
        <Row gutter={12}>
          <Col xs={24} md={12}><Text strong>ชื่อ-นามสกุล:</Text> <span> {doc.section1?.fullName || '-'}</span></Col>
          <Col xs={24} md={12}><Text strong>ชื่อผู้บังคับบัญชา:</Text> <span> {doc.section1?.supervisorName || '-'}</span></Col>
          <Col xs={24} md={12}><Text strong>ตำแหน่ง:</Text> <span> {doc.section1?.position || '-'}</span></Col>
          <Col xs={24} md={12}><Text strong>เบอร์ติดต่อ:</Text> <span> {doc.section1?.phone || '-'}</span></Col>
          <Col xs={24} md={12}><Text strong>วันที่เริ่มงาน:</Text> <span> {doc.section1?.startDate ? new Date(doc.section1.startDate).toLocaleDateString() : '-'}</span></Col>
          <Col xs={24} md={12}><Text strong>วันที่ทำประเมิน:</Text> <span> {doc.section1?.evaluationDate ? new Date(doc.section1.evaluationDate).toLocaleDateString() : '-'}</span></Col>
        </Row>
      </Card>

      <Card title="ส่วนที่ 2 การประเมินผลสัมฤทธิ์ของงาน">
        {groupByArea(doc.section2).map(g => (
          <Card key={g.area} size="small" title={g.area} style={{ marginBottom: 12 }}>
            {g.items.map(it => (
              <Row key={`${g.area}-${it.idx}`} gutter={8} style={{ padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                <Col xs={24} md={10}><Text strong>{it.idx}. {it.title}</Text><div><Text type="secondary">{it.description}</Text></div></Col>
                <Col xs={8} md={4}><Text>น้ำหนัก (A): {it.weightA}</Text></Col>
                <Col xs={8} md={4}><Text>เลือก (B): {it.choiceB}</Text></Col>
                <Col xs={8} md={3}><Text>เต็ม (A×5): {it.fullMark}</Text></Col>
                <Col xs={24} md={3}><Text strong>ได้ (A×B): {it.earned}</Text></Col>
              </Row>
            ))}
          </Card>
        ))}
      </Card>

      {/* >>> UPDATED: ส่วนที่ 3 ใหม่ */}
      <Card title="ส่วนที่ 3">
        <div style={{ marginBottom: 12 }}>
          <Title level={5}>
            1.&nbsp;
            {doc.type === 'NewBiz'
              ? 'ระบุผลงาน (โครงการ) ใดของคุณที่เห็นผลชัดเจนและช่วยสร้างรายได้ให้แก่บริษัท (ในปี 68)'
              : 'งานหรือผลงานใดของคุณที่เห็นผลชัดเจนและเป็นประโยชน์ต่อบริษัท (ในปี 68)'}
          </Title>
          <ol>{(doc.section3?.workProjects || []).map((t,i) => <li key={i}>{t || '-'}</li>)}</ol>
        </div>

        <Divider />

        <div>
          <Title level={5}>2. เส้นทางเพื่อสร้างความเจริญก้าวหน้าสายอาชีพในอนาคต (Journey Line for Career Path)</Title>
          <Row gutter={12}>
            <Col xs={24} md={12}>
              <Text strong>พลังบวกในการทำงานปัจจุบัน (5 Emotional Energy +)</Text>
              <ol>{(doc.section3?.positives || []).map((t,i) => <li key={i}>{t || '-'}</li>)}</ol>
            </Col>
            <Col xs={24} md={12}>
              <Text strong>พลังลบในการทำงานปัจจุบัน (5 Emotional Energy -)</Text>
              <ol>{(doc.section3?.negatives || []).map((t,i) => <li key={i}>{t || '-'}</li>)}</ol>
            </Col>
          </Row>
        </div>
      </Card>

      <Card title="ส่วนที่ 4 ความคิดเห็นเพิ่มเติม">
        <p><Text strong>ปัญหาและอุปสรรค:</Text><br />{doc.section4?.obstacles || '-'}</p>
        <Divider />
        <p><Text strong>ความคิดเห็น/ข้อเสนอแนะ:</Text><br />{doc.section4?.suggestions || '-'}</p>
      </Card>
    </div>
  );
}

function groupByArea(items) {
  const map = new Map();
  (items || []).forEach(it => {
    if (!map.has(it.area)) map.set(it.area, []);
    map.get(it.area).push(it);
  });
  return Array.from(map.entries()).map(([area, items]) => ({ area, items }));
}
